import type {RGBA} from '@Utils/color.util';

export enum FillTypes {
  SOLID = 0,
  LINEAR_GRADIENT = 1,
  RADIAL_GRADIENT = 2,
  NONE = 3,
}

export interface FillObject {
  fillType: FillTypes;
  fillColor: RGBA[];
}

export const DEFAULT_FILL_COLOR: RGBA = [0, 0, 0, 1];

export const hasFill = (fill: FillObject): boolean => {
  return fill.fillType !== FillTypes.NONE;
};

export const hasLinearGradientFill = (fill: FillObject): boolean => {
  return fill.fillType === FillTypes.LINEAR_GRADIENT;
};

export const hasRadialGradientFill = (fill: FillObject): boolean => {
  return fill.fillType === FillTypes.RADIAL_GRADIENT;
};

export const hasGradientFill = (fill: FillObject): boolean => {
  return hasLinearGradientFill(fill) || hasRadialGradientFill(fill);
};
